import { useCallback } from 'react';
import * as Sentry from '@sentry/react';

interface ErrorContext {
  userId?: string;
  page?: string;
  action?: string;
  [key: string]: any;
}

export const useSentry = () => {
  const captureError = useCallback((error: Error, context?: ErrorContext) => {
    Sentry.withScope((scope) => {
      if (context) {
        // Set user context
        if (context.userId) {
          scope.setUser({ id: context.userId });
        }
        
        // Set additional context
        scope.setContext('error_context', context);
        
        // Set tags for filtering
        if (context.page) scope.setTag('page', context.page);
        if (context.action) scope.setTag('action', context.action);
      }
      
      Sentry.captureException(error);
    });
  }, []);

  const captureMessage = useCallback((
    message: string, 
    level: 'debug' | 'info' | 'warning' | 'error' | 'fatal' = 'info',
    context?: ErrorContext
  ) => {
    Sentry.withScope((scope) => {
      if (context) {
        scope.setContext('message_context', context);
      }
      Sentry.captureMessage(message, level);
    });
  }, []);

  const setUserContext = useCallback((user: { id: string; email?: string; username?: string }) => {
    Sentry.setUser(user);
  }, []);

  return {
    captureError,
    captureMessage,
    setUserContext,
  };
};